import { Injectable } from '@angular/core';
import { TableColumn } from '../../models/table-column';
import { OrderListStore } from './order-list.store';
import { TableColumnService } from '../../interfaces/table/table-column.service';
import { FilterService } from '../../interfaces/filter/filter-service';
import { take } from 'rxjs/operators';
import { OrderListQuery } from './order-list.query';
import { LocalStoreConfigModel } from '../../models/local-store-config.model';
import { OrderListParameters } from '../../models/client-models';

@Injectable({
  providedIn: 'root',
})
export class OrderListService implements TableColumnService, FilterService {
  constructor(
    private orderListStore: OrderListStore,
    private orderListQuery: OrderListQuery
  ) {}

  setFilter(oderParams: OrderListParameters): OrderListParameters {
    this.orderListQuery.filterOptions$.pipe(take(1)).subscribe((values) => {
      oderParams.orderNumber = values.orderNumber.selected;
      oderParams.orderName = values.orderName.selected;
      oderParams.orderDescription = values.orderDescription.selected;
      oderParams.customerNumber = values.customerNumber.selected;
      oderParams.customerName = values.customerName.selected;
      oderParams.filterAll =
        !values.orderNumber.selected &&
        !values.orderName.selected &&
        !values.orderDescription.selected &&
        !values.customerNumber.selected &&
        !values.customerName.selected;
    });
    return oderParams;
  }

  showSelectedColumns(columns: TableColumn[]): void {
    this.orderListStore.update((state) => ({
      ...state,
      columns,
    }));
  }

  setFilterOptions(
    filterSelection: any,
    storeConfig?: LocalStoreConfigModel
  ): void {
    this.orderListStore.update((state) => ({
      ...state,
      filterOptions: filterSelection,
    }));
  }

  clearFilterValue() {
    this.orderListStore.update((state) => ({
      ...state,
      filterValue: '',
    }));
  }

  filterValueChange(filterValue: string) {
    this.orderListStore.update((state) => ({
      ...state,
      filterValue,
    }));
  }
}
